import { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import { Box } from '@givebutter/primitives/box';
import { BoxIcon } from '@givebutter/primitives/box-icon';
import { twMerge } from 'tailwind-merge';

interface MetricCardRootProps extends ComponentPropsWithoutRef<'div'> {}
interface MetricCardHeaderProps extends ComponentPropsWithoutRef<'div'> {}
interface MetricCardTitleProps extends ComponentPropsWithoutRef<'div'> {}
interface MetricCardIconProps extends ComponentPropsWithoutRef<'div'> {}
interface MetricCardValueProps extends ComponentPropsWithoutRef<'div'> {}
interface MetricCardContentProps extends ComponentPropsWithoutRef<'div'> {}

const MetricCardRoot = ({
    children,
    className,
    ...props
}: PropsWithChildren<MetricCardRootProps>) => {
    return (
        <Box className={twMerge('flex gap-4 p-4', className)} {...props}>
            {children}
        </Box>
    );
};

const MetricCardHeader = ({
    children,
    className,
    ...props
}: PropsWithChildren<MetricCardHeaderProps>) => {
    return (
        <div className={twMerge('flex w-full items-center justify-between', className)} {...props}>
            {children}
        </div>
    );
};

const MetricCardTitle = ({
    children,
    className,
    ...props
}: PropsWithChildren<MetricCardTitleProps>) => {
    return (
        <div className={twMerge('text-sm font-light text-gray-600', className)} {...props}>
            {children}
        </div>
    );
};

const MetricCardIcon = ({
    children,
    className,
    ...props
}: PropsWithChildren<MetricCardIconProps>) => {
    return (
        <BoxIcon size="md" className={twMerge(className)} {...props}>
            {children}
        </BoxIcon>
    );
};

const MetricCardValue = ({
    children,
    className,
    ...props
}: PropsWithChildren<MetricCardValueProps>) => {
    return (
        <div className={twMerge('text-2xl font-medium text-gray-900', className)} {...props}>
            {children}
        </div>
    );
};

const MetricCardContent = ({
    children,
    className,
    ...props
}: PropsWithChildren<MetricCardContentProps>) => {
    return (
        <div className={twMerge('flex w-full flex-col', className)} {...props}>
            {children}
        </div>
    );
};

const Root = MetricCardRoot;
const Header = MetricCardHeader;
const Title = MetricCardTitle;
const Icon = MetricCardIcon;
const Value = MetricCardValue;
const Content = MetricCardContent;

export {
    MetricCardRoot,
    MetricCardHeader,
    MetricCardTitle,
    MetricCardIcon,
    MetricCardValue,
    MetricCardContent,
    //
    Root,
    Header,
    Title,
    Icon,
    Value,
    Content,
};
